// src/components/Footer.js
import React from "react";
import ScrollToTop from "react-scroll-up";
import { Box, Button, Container, Typography } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

function Footer() {
  return (
    <Container maxWidth="xxl" sx={{ mt: "auto", px: "0px !important" }}>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        component="footer"
        sx={{ py: 3, textAlign: "center", mt: "auto" }}
      >
        <Typography
          variant="body2"
          color="secondary.text"
          sx={{
            width: {
              xs: "80%",
              sm: "100%",
            },
            textAlign: "left",
          }}
        >
          COPYRIGHT © {new Date().getFullYear()} BYLD Network, All rights
          reserved
        </Typography>
        <ScrollToTop
          showUnder={160}
          style={{ bottom: "20px", right: "160px", zIndex: 1000 }}
        >
          <Button
            variant="contained"
            color="secondary"
            sx={{
              px: 1,
              py: 1,
              margin: 0,
              "& .MuiButton-startIcon": {
                margin: 0,
              },
            }}
            startIcon={<KeyboardArrowUpIcon />}
          />
        </ScrollToTop>
      </Box>
    </Container>
  );
}

export default Footer;
